import { Component, OnInit } from '@angular/core';
import { LandingpageService } from 'src/app/_services/landingpage.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.scss']
})
export class CategoryComponent implements OnInit {

  slug = this.actRoute.snapshot.params['slug'];
  category_data: any;

  blogs: any;
  categories: any;
  populars: any;
  page = 1;
  pageSize = 6;
  pageLength = 0;
  hideLoader = true;
  lastData = false;

  constructor(
    private actRoute: ActivatedRoute,
    private landing: LandingpageService
  ) { }

  ngOnInit() {
    this.loadData();
  }

  loadData(isPrev = false) {
    this.landing.getBlogCategory({pageSize: this.pageSize, page: this.page, slug: this.slug})
      .subscribe(arg => {
        if (arg.status) {
          this.category_data = arg.result.row.category_data;
          this.blogs = arg.result.row.blog;
          this.categories = arg.result.row.category;
          this.populars = arg.result.row.popular;
          if (!isPrev) {
            this.pageLength += this.blogs.length;
          }
          this.lastData = (this.pageLength === arg.result.total);
        } else {
          this.landing.alertModal(arg.message);
        }
        this.hideLoader = true;
      }, error => {
        this.landing.alertModal(error.error.message, error.error.status_code);
        this.hideLoader = true;
      });
  }

  previousPage() {
    this.hideLoader = false;
    this.page -= 1;
    this.pageLength -= this.blogs.length;
    this.loadData(true);
  }
  nextPage() {
    this.hideLoader = false;
    this.page += 1;
    this.loadData();
  }
  reloadPage($event) {
    this.slug = $event;
    this.category_data = undefined;
    this.blogs = undefined;
    this.page = 1;
    this.pageLength = 0;
    this.loadData();
  }

}
